/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { User } from './user';
import { DeckPitchSimple } from './deck-pitch-simple';

/**
 * General serializer for Analysis model
 */
export interface DeckAnalysis {
  readonly id: string;
  readonly user: User;
  readonly pitch: DeckPitchSimple;
  readonly title: string;
  readonly text: string;
  readonly muted: boolean;
  readonly rating: number | null;
}
